import { useMutation } from "@tanstack/react-query";
import { useClientContext } from "clients";

type Request = {
  password: string;
  code?: string;
  email: string;
};

const useForgotPasswordVerification = () => {
  const clients = useClientContext();
  return useMutation({
    mutationFn: (req: Request) =>
      clients.management.forgetPasswordVerification(req),
  });
};

export default useForgotPasswordVerification;
